import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Menu, Icon } from 'semantic-ui-react';


class Pagination extends Component {
    constructor(props){
        super(props);
        this.onClick = this.onClick.bind(this);
    }
    onClick(e, {name}){
        e.preventDefault();
        const {activePage, itemsPerPage, onPaginate} = this.props;
        let page = activePage;
        if (name === 'left') page--;
        else if (name === 'right') page++;
        else page = parseInt(name);
        
        const startIndex = (page-1) * itemsPerPage;
        const endIndex = startIndex + itemsPerPage;
        onPaginate({activePage: page, startIndex, endIndex});
    }
    render() {
        const {activePage, itemsPerPage, totalItems, pageRangeDisplayed, floated} = this.props;
        const totalPages = Math.ceil(totalItems / itemsPerPage);
        const middlePage = pageRangeDisplayed * 0.6;
        const upperHalf = pageRangeDisplayed * 0.4;
        let startPage, endPage;
        if (totalPages <= pageRangeDisplayed){
            startPage=1;
            endPage=totalPages;
        } else {
            if (activePage < middlePage) {
                startPage = 1;
                endPage = pageRangeDisplayed;
            } else if (activePage + upperHalf >= totalPages) {
                startPage = totalPages - (pageRangeDisplayed - 1);
                endPage = totalPages;
            } else {
                startPage = activePage - (middlePage - 1);
                endPage = activePage + upperHalf;
            }
        }
        let pages = Array.from(Array(totalPages+1).keys());
        pages = pages.slice(startPage, endPage+1);
        return (
            <Menu pagination floated={floated}>
                <Menu.Item name="left" as="a" icon onClick={this.onClick} disabled={activePage <= 1}>
                    <Icon name="left chevron" />
                </Menu.Item>
                {pages.map((p) => <Menu.Item key={p} name={p.toString()} active={p === activePage} as="a" onClick={this.onClick}>{p}</Menu.Item>)}
                <Menu.Item name="right" as="a" icon onClick={this.onClick} disabled={activePage >= totalPages}>
                    <Icon name="right chevron" />
                </Menu.Item>
            </Menu>
        );
    }
}

Pagination.propTypes = {
    activePage: PropTypes.number.isRequired,
    itemsPerPage: PropTypes.number.isRequired,
    totalItems: PropTypes.number.isRequired,
    pageRangeDisplayed: PropTypes.number.isRequired,
    onPaginate: PropTypes.func.isRequired,
    size: PropTypes.string,
    floated: PropTypes.string,
};

export default Pagination;